namespace Ir.Components.RelationshipEditor.RelationshipEditor {
    interface IViewModel {
        dataGridOptions: DevExpress.ui.dxDataGrid.Properties;
        dataGridComponent: DevExpress.ui.dxDataGrid;
        dataGridFieldsComponent: DevExpress.ui.dxDataGrid;
        relationships: Array<Relationship>;
        tables: Array<RelationshipTableVM>;
        fields: Array<RelationshipTableFieldVM>;
    }
    interface IParams {
        mappingId: number;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        load(self, params);

        let childTableId: number;
        let editingRelationship: Relationship = null;
        let copyRelationship: Relationship = null;
        let store = new DevExpress.data.CustomStore({
            key: "id",
            load: function () {
                return self.relationships;
            },
            insert: function (values) {
                let d = $.Deferred();

                let relationship = editingRelationship;
                relationship.save(params.mappingId, true, function (result) {
                    relationship.id = result.id;
                    if (relationship.fields) {
                        for (var i = 0; i < relationship.fields.length; i++) {
                            relationship.fields[i].id = result.fields[i];
                        }
                    }

                    d.resolve(relationship);
                }, function () {
                    d.resolve(false);
                });

                self.relationships.push(relationship);
                forceTablesUpdate();

                return d.promise();
            },
            update: function (key, values) {
                let d = $.Deferred();

                let filtered = self.relationships.filter(function (value) {
                    return value.id === key;
                });
                if (filtered.length === 1) {
                    let relationship = filtered[0];

                    Object.assign(relationship, values);
                    relationship.save(params.mappingId, false, function () {
                        d.resolve();
                    }, function () {
                        d.resolve(false);
                    });
                }
                else {
                    d.resolve();
                }

                forceTablesUpdate();
                return d.promise();
            },
            remove: function (key) {
                let d = $.Deferred();
                let relationship = self.relationships.find(function (value) {
                    return value.id === key;
                });
                if (relationship) {
                    relationship.delete(params.mappingId, function (result) {
                        if (result.success) {
                            let profiles = self.relationships.filter(function (value) {
                                return value.id !== key;
                            });
                            self.relationships = profiles;
                            d.resolve(true);
                        }
                        else {
                            irGlobal.defaultErrorFunction("Failed to delete relationship", result.message, "");
                            d.resolve(false);
                        }
                    });
                }

                forceTablesUpdate();
                return d.promise();
            }
        });

        self.dataGridOptions = {
            height: "100%",
            width: "100%",
            paging: {
                enabled: false
            },
            dataSource: store,
            columns: [{ dataField: "id", visible: false },
            {
                dataField: "parentTableId",
                caption: "Parent Table",
                lookup: {
                    dataSource: self.tables.filter(x => x.isPrinciple),
                    displayExpr(e: RelationshipTableVM) {
                        return replaceBasicHtmlContent(e?.displayName);
                    },
                    valueExpr: 'id',
                },
                validationRules: [{ type: 'required' }]
            },
            {
                dataField: "joinType",
                caption: "Type",
                width: 100,
                lookup: {
                    dataSource: [
                        { id: JoinTypeEnum.Left, name: "Left" },
                        { id: JoinTypeEnum.Inner, name: "Inner" }
                    ],
                    displayExpr: 'name',
                    valueExpr: 'id',
                },
                validationRules: [{ type: 'required' }]
            },
            {
                dataField: "childTableId",
                caption: "Child Table",
                lookup: {
                    dataSource: self.tables.filter(x => !x.isPrinciple),
                    displayExpr(e: RelationshipTableVM) {
                        return replaceBasicHtmlContent(e?.displayName);
                    },
                    valueExpr: 'id',
                },
                setCellValue(rowData: Relationship, value, currentRowData: Relationship) {
                    childTableId = value;
                    rowData.childTableId = value;
                    rowData.fields = [];

                    if (self.dataGridFieldsComponent.hasEditData()) {
                        self.dataGridFieldsComponent.cancelEditData();
                    }

                    if (value) {
                        self.dataGridFieldsComponent.option("editing.allowAdding", true);
                        setTimeout(function () { self.dataGridFieldsComponent.addRow(); }, 100)                        
                    }
                },
                validationRules: [{ type: 'required' }]
            },
            {
                dataField: "parentFieldsName",
                caption: "Parent Fields",
            },
            {
                dataField: "childFieldsName",
                caption: "Child Fields",
            },
            {
                dataField: "fields",
                caption: "Fields",
                visible: false,
                editCellTemplate: function (cellElement, cellInfo) {
                    let divGrid = $("<div>").dxDataGrid({
                        dataSource: editingRelationship.fields,
                        keyExpr: "id",
                        columns: [
                            { dataField: "id", visible: false },
                            {
                                dataField: "parentFieldId",
                                caption: "Parent Field",
                                lookup: {
                                    dataSource: self.fields,
                                    displayExpr(e: RelationshipTableFieldVM) {
                                        return replaceBasicHtmlContent(e?.displayName);
                                    },
                                    valueExpr: 'id',
                                },
                                setCellValue(rowData: RelationshipField, value, currentRowData: RelationshipField) {
                                    rowData.parentFieldId = value;

                                    let parentField = (getParentTable(self, editingRelationship)?.fields || []).find(x => x.id === rowData.parentFieldId);
                                    let childField = (getChildTable(self, editingRelationship)?.fields || []).find(x => x.id === currentRowData.childFieldId);
                                    if (!childField || (childField && parentField && parentField.type !== childField.type)) {
                                        rowData.childFieldId = null;
                                    }
                                },
                                //validationRules: [{ type: 'required' }]
                            },
                            {
                                dataField: "childFieldId",
                                caption: "Child Field",
                                lookup: {
                                    dataSource: self.fields,
                                    displayExpr(e: RelationshipTableFieldVM) {
                                        return replaceBasicHtmlContent(e?.displayName);
                                    },
                                    valueExpr: 'id',
                                },
                                setCellValue(rowData, value, currentRowData: RelationshipField) {
                                    rowData.childFieldId = value;

                                    let parentField = (getParentTable(self, editingRelationship)?.fields || []).find(x => x.id === currentRowData.parentFieldId);
                                    let childField = (getChildTable(self, editingRelationship)?.fields || []).find(x => x.id === rowData.childFieldId);
                                    if (!parentField || (childField && parentField && parentField.type !== childField.type)) {
                                        rowData.parentFieldId = null;
                                    }
                                },
                                //validationRules: [{ type: 'required' }]
                            }
                        ],
                        height: 200,
                        paging: {
                            enabled: false
                        },
                        scrolling: {
                            useNative: false
                        },
                        showBorders: false,
                        editing: {
                            mode: 'cell',
                            allowUpdating: true,
                            allowDeleting: true,
                            allowAdding: editingRelationship.childTableId > 0,
                            useIcons: true,
                            confirmDelete: false
                        },
                        onInitialized(e) {
                            self.dataGridFieldsComponent = e.component;
                        },
                        onInitNewRow(e) {
                            let newField = new RelationshipField();
                            let parentTable = self.tables.find(x => x.id === editingRelationship.parentTableId);

                            let childFields = self.tables.find(x => x.id === (childTableId ?? editingRelationship.childTableId))?.fields?.filter(x => x.visible);
                            if (childFields.length > 0) {
                                let childField = childFields[0];

                                let parentFields = parentTable.fields.filter(x => x.visible);
                                let parentFieldName = findBestMatch(childField.name, parentFields.map(x => x.name));
                                if (parentFieldName) {
                                    let parentField = parentFields.find(x => x.name === parentFieldName);                                    
                                    if (parentField.type === childField.type && !editingRelationship.fields.find(x => x.parentFieldId === parentField.id)) {
                                        newField.childFieldId = childFields[0].id;
                                        newField.parentFieldId = parentFields.find(x => x.name === parentFieldName).id;

                                        setTimeout(function () {
                                            self.dataGridFieldsComponent.saveEditData();
                                        }, 100);
                                    }
                                }
                            }
                            
                            e.data = newField;
                        },
                        onEditorPreparing(e) {
                            if (e.parentType === "dataRow") {
                                if (e.dataField === "childFieldId" || e.dataField === "parentFieldId") {
                                    e.editorOptions.showClearButton = true;
                                    let editingRelationshipField = e.row.data;
                                    let parentField = (getParentTable(self, editingRelationship)?.fields || []).find(x => x.id === editingRelationshipField.parentFieldId);
                                    let childField = (getChildTable(self, editingRelationship)?.fields || []).find(x => x.id === editingRelationshipField.childFieldId);
                                    let type = parentField ? parentField.type : childField ? childField.type : null;
                                    let visibleFilter = editingRelationshipField.id <= 0 ? true : false;

                                    if (e.dataField === "parentFieldId") {
                                        e.editorOptions.dataSource = self.fields.filter(x => x.tableId === editingRelationship?.parentTableId && (type ? x.type === type : true) && (visibleFilter ? x.visible : true));
                                        e.editorOptions.onValueChanged = (valueChangeEvent: any) => {
                                            e.component.cellValue(e.row.rowIndex, 'parentFieldId', valueChangeEvent.value);
                                            e.component.saveEditData();
                                        };
                                    }
                                    else if (e.dataField === "childFieldId") {
                                        e.editorOptions.dataSource = self.fields.filter(x => x.tableId === editingRelationship?.childTableId && (type ? x.type === type : true) && (visibleFilter ? x.visible : true));
                                        e.editorOptions.onValueChanged = (valueChangeEvent: any) => {
                                            e.component.cellValue(e.row.rowIndex, 'childFieldId', valueChangeEvent.value);
                                            e.component.saveEditData();
                                        };
                                    }
                                }
                            }
                        },
                        onSaved(e) {
                            if (editingRelationship) {
                                e.changes.forEach(function (row) {
                                    if (row.type === "insert") {
                                        if (!editingRelationship.fields.find(x => x.id === row.data.id)) {
                                            editingRelationship.fields.push(row.data);
                                        }
                                    }
                                });

                                updateFieldsName(self, editingRelationship);

                                self.dataGridComponent.cellValue(self.dataGridComponent.getRowIndexByKey(editingRelationship.id), "fields", editingRelationship.fields);
                            }
                        },
                        onRowRemoved(e) {
                            const index = editingRelationship.fields.indexOf(e.data);
                            if (index > -1) {
                                editingRelationship.fields.splice(index, 1);
                            }

                            self.dataGridComponent.cellValue(self.dataGridComponent.getRowIndexByKey(editingRelationship.id), "fields", editingRelationship.fields);
                        }
                    });
                    return divGrid;
                }
            },
            ],
            showBorders: true,
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowDeleting: true,
                allowAdding: true,
                useIcons: true,
                popup: {
                    title: 'Relationship',
                    showTitle: true,
                    width: 500,
                    height: 420,
                    toolbarItems: [{
                        toolbar: "bottom",
                        widget: "dxButton",
                        location: "after",
                        options: {
                            icon: 'save',
                            stylingMode: 'contained',
                            type: 'default',
                            text: "Save",
                            onClick: function () {
                                self.dataGridComponent.saveEditData();
                            }
                        }
                    }, {
                        toolbar: "bottom",
                        widget: "dxButton",
                        location: "after",
                        options: {
                            text: 'Cancel',
                            icon: 'remove',
                            stylingMode: 'outlined',
                            type: 'normal',
                            onClick: function () {
                                self.dataGridComponent.cancelEditData();
                            }
                        }
                    }]
                },
                form: {
                    items: [{
                        itemType: 'group',
                        colCount: 2,
                        colSpan: 2,
                        items: [
                            { dataField: 'parentTableId', colSpan: 2, disabled: true } as any,
                            { dataField: 'joinType', colSpan: 2 },
                            { dataField: 'childTableId', colSpan: 2 },
                            { dataField: 'fields', colSpan: 2 },
                        ],
                    }],
                }
            },
            toolbar: {
                items: [
                    {
                        name: "addRowButton", cssClass: "customAddRowDataGridAdmin", location: "before",
                        widget: 'dxButton',
                        options: {
                            text: 'Create Relationship',
                            onClick: function (e) {
                                childTableId = null;

                                if (!self.tables.find(x => x.isPrinciple)) {
                                    DevExpress.ui.notify("Relationship cannot be created until a principle table has been defined for this mapping");
                                    return;
                                }

                                let tablesId = self.relationships.map(x => x.childTableId);
                                if (self.tables.filter(x => tablesId.indexOf(x.id) === -1 && x.visible && !x.isPrinciple).length === 0) {
                                    DevExpress.ui.dialog.alert(`All possible relationships have been defined for this mapping`, "Relationship");
                                    return;
                                }

                                self.dataGridComponent.addRow();
                            }
                        }
                    }
                ]
            },
            repaintChangesOnly: true,
            focusedRowEnabled: true,
            keyExpr: "id",
            focusedRowIndex: 0,
            searchPanel: {
                visible: false,
                highlightSearchText: true,
            },
            scrolling: {
                useNative: false
            },
            onInitialized(e) {
                self.dataGridComponent = e.component;
            },
            onInitNewRow(e) {
                let newRelationship = new Relationship();
                newRelationship.parentTableId = self.tables.find(x => x.isPrinciple)?.id;

                e.data = newRelationship;
            },
            onRowInserted(e) {
                e.component.option("focusedRowKey", e.data.id);
            },
            onEditorPreparing(e) {
                if (e.parentType === "dataRow") {
                    editingRelationship = e.row.data;
                    if (e.dataField === "childTableId") {
                        if (editingRelationship.id > 0) {
                            e.editorOptions.dataSource = self.tables.filter(x => x.id === editingRelationship.childTableId);
                            e.editorOptions.disabled = true;
                        }
                        else {
                            let tablesId = self.relationships.map(x => x.childTableId);
                            e.editorOptions.dataSource = self.tables.filter(x => tablesId.indexOf(x.id) === -1 && x.visible && !x.isPrinciple);
                        }
                    }
                }
            },
            onSaving(e) {
                if (editingRelationship && (editingRelationship.fields.length === 0 || editingRelationship.fields.filter(x => !x.childFieldId || !x.parentFieldId).length > 0)) {
                    DevExpress.ui.dialog.alert(`Fields are required`, "Relationship");
                    e.cancel = true;
                    return;
                }
            },
            onSaved() {
                editingRelationship = null;
                copyRelationship = null;
            },
            onEditingStart(e) {
                //Copied the properties because we have a problem with the field list when you add/remove a field and then cancel the edit
                copyRelationship = new Relationship(e.data);
            },
            onEditCanceled(e) {
                if (copyRelationship) {
                    //Restore properties and update the grid
                    copyProperties(copyRelationship, editingRelationship);
                    copyRelationship = null;
                    e.component.refresh();
                }
                editingRelationship = null;
            },
            onRowRemoved() {
                editingRelationship = null;
                copyRelationship = null;
            }
        };
    }
    function load(self: IViewModel, params: IParams) {
        self.relationships = [];
        self.tables = [];
        self.fields = [];
        
        let o = {
            url: `${urlConfigs.relationship}/GetRelationships`,
            data: { mappingId: params.mappingId },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result: any, e) {
            self.tables = result.tables;

            let fields = [];
            self.tables.forEach(function (table: RelationshipTableVM) {
                fields = fields.concat(table.fields);
            });
            self.fields = fields;

            self.relationships = createInstances(Relationship, result.relationships ?? []);
            self.relationships.forEach(x => updateFieldsName(self, x));
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get relationships";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    function forceTablesUpdate() {
        $(`#MappingDetailTabs a[href="#tables"]`).removeAttr("loaded");
    }

    function updateFieldsName(self: IViewModel, relationship: Relationship) {
        relationship.parentFieldsName = "";
        relationship.childFieldsName = "";

        let parentTable = self.tables.find(x => x.id === relationship.parentTableId);
        let childTable = self.tables.find(x => x.id === relationship.childTableId);
        for (let field of relationship.fields) {
            if (relationship.parentFieldsName !== "") {
                relationship.parentFieldsName += ", ";
            }
            if (relationship.childFieldsName !== "") {
                relationship.childFieldsName += ", ";
            }

            relationship.parentFieldsName += replaceBasicHtmlContent(parentTable ? parentTable.fields.find(x => x.id === field.parentFieldId)?.displayName || "" : "");
            relationship.childFieldsName += replaceBasicHtmlContent(childTable ? childTable.fields.find(x => x.id === field.childFieldId)?.displayName || "" : "");
        }
    }

    function getParentTable(self: IViewModel, relationship: Relationship): RelationshipTableVM {
        return self.tables.find(x => x.id === relationship?.parentTableId);
    }
    function getChildTable(self: IViewModel, relationship: Relationship): RelationshipTableVM {
        return self.tables.find(x => x.id === relationship?.childTableId);
    }

    //************ IA CODE *************/
    function normalize(columnName) {
        return columnName
            .toLowerCase()
            .replace(/_/g, '')
            .replace(/[^a-z0-9]/g, '');
    }

    function areSimilar(nameA, nameB) {
        const minLength = 3;
        const lengthA = nameA.length;
        const lengthB = nameB.length;

        if (lengthA < minLength || lengthB < minLength) {
            return false;
        }

        const shorter = lengthA < lengthB ? nameA : nameB;
        const longer = lengthA >= lengthB ? nameA : nameB;

        const percentage = shorter.length / longer.length;

        return (longer.includes(shorter) && percentage >= 0.7);
    }

    function findBestMatch(columnName, columnsArray) {
        const normalizedInput = normalize(columnName);
        const normalizedColumns = columnsArray.map(name => ({ original: name, normalized: normalize(name) }));

        const match = normalizedColumns.find(col => areSimilar(normalizedInput, col.normalized));

        return match ? match.original : null;
    }
    //************ IA CODE *************/


    //Remove
    function copyProperties(fromObject, toObject) {
        for (let property in fromObject) {
            if (fromObject[property] !== undefined) {
                let fromValue = typeof fromObject[property] === "function" ? fromObject[property]() : fromObject[property];
                if (fromValue === null)
                    fromValue = null;
                else if (fromValue === undefined)
                    fromValue = undefined;
                else if (Array.isArray(fromValue))
                    fromValue = fromValue.slice();
                else if (typeof fromValue === "object")
                    fromValue = {};

                if (typeof toObject[property] === "function")
                    toObject[property](fromValue);
                else
                    toObject[property] = fromValue;
            }
        }
    }
}